import { useSelector } from 'react-redux';
import { ApplicationState } from '../../reducers';

export const useIsStreamConnected = (): boolean => {
  return useSelector((state: ApplicationState) => state.app.streamConnected);
};
